import { render, staticRenderFns } from "./NewCategory.vue?vue&type=template&id=52fa8262&scoped=true&"
import script from "./NewCategory.vue?vue&type=script&lang=js&"
export * from "./NewCategory.vue?vue&type=script&lang=js&"
import style0 from "./NewCategory.vue?vue&type=style&index=0&id=52fa8262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fa8262",
  null
  
)

export default component.exports